export default {
  // Sunny
  // STATIC_URL: 'http://157.230.41.65:8002/',
  // BASE_URL: 'http://157.230.41.65:8002/v1',
  // MQTT_URL: 'ws://157.230.41.65',

  // MQTT_PORT: 8083,
  // MQTT_USER: 'dashboard',
  // MQTT_PASSWORD: 'db01',

  MQTT_PORT: 8083,
  MQTT_USER: 'user1',
  MQTT_PASSWORD: 'P@$$w0rd', 

  // My Server
  STATIC_URL: 'http://167.71.223.60:8002/',
  BASE_URL: 'http://167.71.223.60:8002/v1',
  MQTT_URL: 'ws://167.71.223.60',

  // NSTDA
  // STATIC_URL: 'http://178.128.127.85:8002/',
  // BASE_URL: 'http://178.128.127.85:8002/v1',
  // MQTT_URL: 'ws://178.128.127.85',

  //Local
  // STATIC_URL: 'http://localhost:8002/',
  // BASE_URL: 'http://localhost:8002/v1',
  // MQTT_URL: 'ws://167.71.223.60',

}
